import { Insurance, RelationshipToSubscriber } from './insurance.model';

import { PatientAppointment } from './patients.model';
import { Payer } from './payer.model';
import { Provider } from './provider.model';

export type EligibilitySummary = {
  pending: string;
  inProgress: string;
  error: string;
  verified: string;
  missingData: string;
};

export enum AppointmentSyncStatus {
  Success = 'Success',
  Failed = 'Failed',
  BatchFailed = 'BatchFailed',
  Invalid = 'Invalid',
  NoInsurance = 'NoInsurance'
}

export enum Appointmentsource {
  ManualEntry = 'ManualEntry',
  Integration = 'Integration',
  PortalImported = 'PortalImported'
}

export enum EligibilityVerificationSource {
  Basic = 'Basic',
  Enhanced = 'Enhanced'
}

export enum EligibilityStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Verified = 'Verified',
  Error = 'Error'
}

export enum EligibilityStatusOverride {
  Cleared = 'Cleared',
  FollowUp = 'FollowUp',
  NeedsAttention = 'NeedsAttention'
}

export enum EligibilityScheduleStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  WaitingForConnection = 'WaitingForConnection',
  WaitingForEligibility = 'WaitingForEligibility',
  Success = 'Success',
  Failed = 'Failed',
  Retry = 'Retry',
  NormalizationInProgress = 'NormalizationInProgress',
  Normalized = 'Normalized',
  CleanedUp = 'CleanedUp'
}

export type Appointment = {
  eligibilityError?: string | null;
  needsApproval?: boolean;
  sourceId?: string;
  sourceName?: string;
  appointmentId: number;
  appointmentAt: Date;
  clinic: string;
  procedureCodes: string[] | null;
  groupId: number;
  patient: PatientAppointment;
  insurance: Insurance;
  provider: Provider[];
  payer: Payer;
  appointmentSyncStatus: AppointmentSyncStatus;
  eligibilityStatus: EligibilityStatus;
  eligibilityStatusOverride: EligibilityStatusOverride | null;
  schedulingErrors?: { message: string; isClientFriendly: boolean }[] | null;
  source: Appointmentsource;
  eligibilityVerificationSource?: EligibilityVerificationSource | null;
  retryCount?: number | null;
  nextRun?: Date | null;
  eligibilityId: number;
  scheduleStatus?: EligibilityScheduleStatus;
  tags?: string[];
};

export type EditedAppointmentData = {
  sourceName: string;
  clinic: string;
  externalAppointmentId: string;
  appointmentAt: Date;
  procedureCodes: (string | null)[] | null;
  patient: {
    firstName: string | null;
    lastName: string | null;
    dob: Date | string | null;
    zipCode: string | null;
    memberId: string | null;
    groupNumber: string | null;
    relationshipToSubscriber: RelationshipToSubscriber;
  };
  subscriber: {
    firstName: string | null;
    lastName: string | null;
    dob: Date | string | null;
    zipCode: string | null;
    memberId: string | null;
    groupNumber: string | null;
  };
  insurance: {
    payerId: number | null;
    payerIdCode: string | null;
    payerName: string | null;
  };
  provider: {
    firstName: string | null;
    lastName: string | null;
    npi: string | null;
    tin: string | null;
  };
};

export type AppointmentSummary = {
  date: Date;
  appointments: number;
};

export type BulkUploadResult = {
  syncId: string;
};

export type BulkUploadFailedResult = {
  [x: string]: {
    path: string;
    message: string;
  }[];
};

export type Tag = {
  id: number;
  tag: string;
  description?: string;
};
